/**
 * Директива v-popup-tall: если высота окна (.popup__window) больше доступной высоты вьюпорта,
 * добавляет класс popup--tall (align-items: flex-start). Прокрутка идёт на контейнере .popup.
 */
const MARGIN_PX = 80; // запас сверху/снизу (padding контейнера + отступ)
const CLASS_TALL = 'popup--tall';

function checkAndToggle(el) {
  if (!el || !document.contains(el)) return;
  const windowEl = el.querySelector('.popup__window');
  if (!windowEl) return;

  const viewportHeight = window.innerHeight;
  const availableHeight = viewportHeight - MARGIN_PX;
  const popupHeight = windowEl.scrollHeight || windowEl.offsetHeight;

  if (popupHeight >= availableHeight) {
    el.classList.add(CLASS_TALL);
  } else {
    el.classList.remove(CLASS_TALL);
  }
}

function setupObserver(el, runCheck) {
  const windowEl = el.querySelector('.popup__window');
  if (!windowEl) return undefined;

  const ro = new ResizeObserver(() => {
    runCheck();
  });
  ro.observe(windowEl);
  return ro;
}

export default {
  mounted(el) {
    const runCheck = () => checkAndToggle(el);
    el._popupTallResize = () => runCheck();
    el._popupTallRO = setupObserver(el, runCheck);
    window.addEventListener('resize', el._popupTallResize);
    // первый раз после отрисовки
    requestAnimationFrame(() => {
      requestAnimationFrame(runCheck);
    });
  },
  updated(el) {
    const runCheck = () => checkAndToggle(el);
    if (el._popupTallRO) {
      el._popupTallRO.disconnect();
    }
    el._popupTallRO = setupObserver(el, runCheck);
    requestAnimationFrame(() => {
      requestAnimationFrame(runCheck);
    });
  },
  unmounted(el) {
    window.removeEventListener('resize', el._popupTallResize);
    if (el._popupTallRO) {
      el._popupTallRO.disconnect();
      el._popupTallRO = null;
    }
    el.classList.remove(CLASS_TALL);
  },
};
